<div class="po-details">
    <div class="modal-body">
        <div class="card p-3 mb-2">
            <div class="row py-1">
                <div class="col-sm-5 border-right">
                    <h2>General Info</h2>
                    <p class="mb-2">
                        <label class="form-label-order">Warehouse Location:&nbsp;</label>
                        <span>{{associateData?.districtName | lowercase}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Type of Manpower Required:&nbsp;</label>
                        <span>{{ getUniqueSkills() }}</span>
                    </p>
                    <!-- <p class="mb-2">
                        <label class="form-label-order">Number of Labourers: </label>
                        <span></span>
                    </p> -->
                    <!-- <p class="mb-2">
                        <label class="form-label-order">Shift Date & Time: </label>
                        <span></span>
                    </p> -->
                    <p class="mb-2">
                        <label class="form-label-order">Status:&nbsp;</label>
                        <span>{{associateData?.status}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Duration:&nbsp;</label>
                        <span>{{associateData?.fromDate | CustomDatePipe: 'D-M-YYYY'}} to {{associateData?.toDate |
                            CustomDatePipe:
                            'D-M-YYYY' }}</span>
                    </p>
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-5">
                    <h2>Contact Person Info</h2>
                    <p class="mb-2">
                        <label class="form-label-order">Name:&nbsp; </label>
                        <span>{{associateData?.contactName}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Mobile Number:&nbsp;</label>
                        <span>{{associateData?.contactMobile}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Alternate Number:&nbsp;</label>
                        <span>{{associateData?.contactAlternateMobile}}</span>
                    </p>
                    <p class="mb-2">
                        <label class="form-label-order">Email:&nbsp;</label>
                        <span>{{associateData?.contactEmail}}</span>
                    </p>
                    <!-- <p class="mb-2">
                        <label class="form-label-order">Status:&nbsp;</label>
                        <span>{{rowData?.status}}</span>
                    </p> -->
                </div>
            </div>
        </div>
        <div class="card p-3 mb-2">
            <div class="table-responsive-scroll">
                <h2>Cost Summary</h2>
                <table class="table mt-2">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th style="min-width: 120px;">Role</th>
                            <th>Basic Wage (By Customer)</th>
                            <th>Basic Wage (For Associate)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of associateData.jobLineItems; let i = index">
                            <td>
                                <input type="radio" name="jobLineItems" [value]="item" [(ngModel)]="jobLineItems" />
                            </td>
                            <td>{{ item.skill }}</td>
                            <td class="vendor-column"> {{ item.vendorPrice != null && item.vendorPrice !== '' ?
                                item.vendorPrice : item.maxSalary }}</td>
                            <td>
                                <input type="text" class="form-control"
                                    [placeholder]="item.vendorPrice != null && item.vendorPrice !== '' ? item.vendorPrice : item.maxSalary"
                                    [(ngModel)]="item.updatedWage" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="btn-block">
                <button class="btn btn-primary mr-2" (click)="showAssociate()" [disabled]="!jobLineItems">
                    Select Associate
                </button>
            </div>
        </div>
        <div class="card p-3" *ngIf="showSelectionCard">
            <h2>Select Associate</h2>
            <div class="row my-2">
                <div class="col-1">
                    <button class="btn btn-primary" (click)="searchDropDownToggle = !searchDropDownToggle"><svg
                            fill="#fff" width="16px" height="16px" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M13.5462318,13 L18.7962318,7 L5.20376823,7 L10.4537682,13 L13.5462318,13 Z M13,15 L11,15 L11,20.0569995 L13,19.3069995 L13,15 Z M4,5 L20,5 L20,4 L4,4 L4,5 Z M9,14.3757351 L2,6.37573512 L2,4 C2,2.8954305 2.8954305,2 4,2 L20,2 C21.1045695,2 22,2.8954305 22,4 L22,6.37573512 L15,14.3757351 L15,20.6930005 L9,22.9430005 L9,14.3757351 Z" />
                        </svg>

                    </button>
                </div>
                <div class="col-11 position-relative">
                    <input type="text" placeholder="Search name" class="search form-control" 
                    [(ngModel)]="UserName"
                    (ngModelChange)="onSearchvendorName($event)">

                    <div class="searchDropdown position-absolute bg-white border p-3 rounded associate-filter"
                        [hidden]="!searchDropDownToggle">
                        <div class="row">
                            <div class="col-6">
                                <label for="skillSelect"><b>Skill</b></label>
                                <ng-select [multiple]="true" appendTo="body" placeholder="Select skill"
                                    [items]="skillSetList" bindValue="id" bindLabel="name"
                                    [(ngModel)]="selectedSkill"></ng-select>
                            </div>
                            <div class="col-6">
                                <label><b>Year of Experience</b></label>
                                <ng-select [multiple]="true" appendTo="body" placeholder="Select skill"
                                    [items]="yearOfExperience" bindValue="id" bindLabel="name"
                                    [(ngModel)]="selectedExperience"></ng-select>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12 associate-filters">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="shortlist"
                                        [(ngModel)]="filter.shortlist" />
                                    <label for="shortlist" class="form-check-label">Shortlist</label>
                                </div>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="acceptance"
                                        [(ngModel)]="filter.associateAcceptance" />
                                    <label for="acceptance" class="form-check-label">Associate Acceptance</label>
                                </div>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="final"
                                        [(ngModel)]="filter.finalAcceptance" />
                                    <label for="final" class="form-check-label">Final Selection</label>
                                </div>
                            </div>


                        </div>

                        <div class="advance-icon flex-row-reverse flex-end justify-content-start">
                            <button class="btn btn-primary ms-1" type="submit" (click)="applyFilter()">Search</button>
                            <button class="btn reset-btn btn-cancel" type="button" (click)="reset()">Reset</button>
                        </div>
                    </div>
                </div>

            </div>
            <div class="table-responsive-scroll">
                <table class="table table-bordered text-center">
                    <thead>
                        <tr>
                            <th>Associate Name</th>
                            <th>Skill</th>
                            <th>Age</th>
                            <th>Experience</th>
                            <!-- <th>Availability</th> -->
                            <!-- <th>Shortlist Associates</th>
                            <th>Associate Acceptance</th>
                            <th>Final Selection</th> -->
                            <!-- Shortlist Associates -->
                            <th>
                                Shortlist Associates <br>
                                <input type="checkbox" class="pointer-checkbox" [(ngModel)]="selectAll.shortlist"
                                    (change)="toggleAll('shortlist', $event)" />
                            </th>

                            <!-- Associate Acceptance -->
                            <th>
                                Associate Acceptance <br>
                                <!-- <input type="checkbox" class="pointer-checkbox"
                                    [(ngModel)]="selectAll.associateAcceptance"
                                    (change)="toggleAll('associateAcceptance', $event)" /> -->
                            </th>

                            <!-- Final Selection -->
                            <th>
                                Final Selection <br>
                                <input type="checkbox" class="pointer-checkbox" [(ngModel)]="selectAll.finalAcceptance"
                                    (change)="toggleAll('finalAcceptance', $event)" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let labor of labourList">

                            <td>{{ labor.name }}</td>
                            <td>
                                <ng-container *ngFor="let skill of labor.skillSet; let i = index">
                                    {{ skill?.skill }}<ng-container *ngIf="i < labor.skillSet.length - 1">,
                                    </ng-container>
                                </ng-container>

                            </td>
                            <td>{{ labor.age }}</td>
                            <td>{{ labor.yearsOfExperience }}</td>
                            <td><input type="checkbox" class="pointer-checkbox" [(ngModel)]="labor.shortlist"
                                    (ngModelChange)="labor.shortlist = $event" /></td>
                            <td><input type="checkbox" class="pointer-checkbox" [(ngModel)]="labor.associateAcceptance"
                                    (ngModelChange)="labor.associateAcceptance = $event" disabled="" /></td>
                            <td>
                                <span class="text-danger">
                                    <input type="checkbox" [(ngModel)]="labor.finalAcceptance" class="pointer-checkbox"
                                        (ngModelChange)="labor.finalAcceptance = $event" />
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex justify-content-start gap-2 mt-2">
                <!-- <button class="btn reset-btn btn-cancel">Save Draft</button> -->
                <button class="btn btn-primary" (click)="submit('SUBMIT')">Send To Associate</button>
            </div>
        </div>
    </div>
</div>